import React from 'react';
import MeinRouter from "./components/Router";


function App() {

  return (
    <>
      <MeinRouter /> 
    </>
  );
}

export default App;
